// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aD","header":"aE","copy":"aF","formLabel":"aG","dismissModal":"aH","buttonRow":"aI","buttonWrapper":"aJ","button":"aK"};